export default "__VITE_ASSET__731f0ec1__"